export default __webpack_public_path__ + "static/media/fasting_ate.a3204fd5.jpg";